import { render } from "./PatientDetails.vue?vue&type=template&id=51e07e90"
import script from "./PatientDetails.vue?vue&type=script&lang=js"
export * from "./PatientDetails.vue?vue&type=script&lang=js"

import "./PatientDetails.vue?vue&type=style&index=0&id=51e07e90&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__